import { Status } from 'src/app/@core/enums/status.enum';

/** Default Custom card design of `app-course-item` when no `cardDesign` is given. */
export const DEFAULT_COURSE_CARD_DESIGN = 4;

export type CourseCardVariant = 'unified' | number;

/**
 * Unified Code criterion 28: in Unified mode every `app-course-item` renders the single Unified card,
 * whatever `cardDesign` the caller passes. Custom mode keeps the requested design (1-4).
 */
export function resolveCourseCardVariant(unified: boolean, cardDesign: number | null | undefined): CourseCardVariant {
  if (unified) return 'unified';

  return cardDesign ?? DEFAULT_COURSE_CARD_DESIGN;
}

/** Registration / enrolment states shown as a status tag on the Unified course card. */
export type RegistrationState =
  | 'registerNow' | 'registered'
  | 'registerSoon' | 'pendingApproval'
  | 'registerEnd' | 'ended' | 'rejected'
  | 'soon';

const REGISTRATION_STATUS: Record<RegistrationState, Status> = {
  registerNow: Status.Active,       // success
  registered: Status.Active,        // success
  registerSoon: Status.Pending,     // warning
  pendingApproval: Status.Pending,  // warning
  registerEnd: Status.Rejected,     // error
  ended: Status.Rejected,           // error
  rejected: Status.Rejected,        // error
  soon: Status.Draft,               // info
};

/**
 * Unified Code criterion 26: maps a registration state to the Status whose tag context it shares, so the
 * card reuses `ucStatusTag()` (open/registered = success, soon/pending = warning, closed/ended/rejected = error,
 * informational = info). Unknown or empty states return null (neutral tag).
 */
export function registrationTagStatus(state: string | null | undefined): Status | null {
  return (state && REGISTRATION_STATUS[state as RegistrationState]) ?? null;
}
